import { ITypeTicketCollectionData } from 'meta/pages/v4/typeticketcollection'
import { useAppSelector } from 'store'
import { TypeTicketCollectionSelectors } from 'store/pages/typeticketcollection'

export const useTypeTicketCollectionData = ({ id }: { id: number }): ITypeTicketCollectionData | undefined =>
  useAppSelector(TypeTicketCollectionSelectors.getTypeTicketCollectionData({ id }))

export const useTypeTicketCollectionBulkData = ({ ids }: {
  ids: number[]
}): ITypeTicketCollectionData[] | undefined => useAppSelector(TypeTicketCollectionSelectors.getTypeTicketCollectionBulkDetails({ ids }))